import http from 'utils/http'
import { MAGIC_LINK_CLIENT_APP } from 'utils/magicLink'

// The shared fetch wrapper resolves non-2xx responses (other than 401/403) with the raw
// Response when autoHandle is false. Turn those into errors that carry the status, so
// callers can tell "expired" from "too many attempts".
function isRawResponse(result) {
  return !!result
    && typeof result.status === 'number'
    && typeof result.ok === 'boolean'
    && typeof result.text === 'function'
}

function parseBody(response) {
  return response.text().then(text => {
    if (!text) {
      return {}
    }
    try {
      return JSON.parse(text)
    } catch (error) {
      return { message: text }
    }
  }, () => ({}))
}

// Readable only if the API exposes it to the browser (CORS); the body is the fallback.
function readRetryAfter(response) {
  try {
    return (response.headers && typeof response.headers.get === 'function'
      && response.headers.get('Retry-After')) || undefined
  } catch (error) {
    return undefined
  }
}

function call(path, body) {
  // autoHandle=false, autoControlSpinner=false: the caller shows its own progress.
  return http.post(path, body, undefined, false, false).then(
    result => {
      if (isRawResponse(result)) {
        if (result.ok) {
          return parseBody(result)
        }
        return parseBody(result).then(data => {
          const error = new Error('Magic link request failed')
          error.status = result.status
          error.data = data
          error.retryAfter = readRetryAfter(result)
          throw error
        })
      }
      return result
    },
    error => {
      if (error && error.response && typeof error.status !== 'number') {
        error.status = error.response.status
      }
      throw error
    }
  )
}

const clientFields = { clientApp: MAGIC_LINK_CLIENT_APP, targetApp: MAGIC_LINK_CLIENT_APP }

// { enabled, enforced, requested, message }. "enforced" is ignored by this site:
// password sign-in is always offered.
const status = email => call('/user/v1/login/magic-link-status', { email, ...clientFields })

// Always answers generically; the backend never says whether the account exists.
const request = email => call('/user/v1/login/request-magic-link', { email, ...clientFields })

// Same response as POST /user/v1/login: the user details body plus the session cookies.
const verify = token => call('/user/v1/login/verify-magic-link', { token, ...clientFields })

export default {
  status,
  request,
  verify,
}



// WEBPACK FOOTER //
// ./src/services/magicLinkService.js